import { useEffect } from 'react';
import { DatePickerCustom, Modal, FormError, FormLabel } from '../../common';
import { useForm } from '@laramie/ui';
import { useFormErrors } from '../../hooks/useFormErrors';
import { truncateTime } from '../../../utils/convert';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const InformeRecaudacionConsolidadaModal = ({ onConfirm, onCancel }) => {

    const [ formValues, formHandle, , formSet ] = useForm({ fecha: null });

    useEffect(() => {
        formSet({ fecha: truncateTime(new Date()) });
    }, []);

    const getErrors = () => {
        const errors = {};
        if (!formValues.fecha) errors.fecha = VALIDATION_MESSAGE.REQUIRED_DATE;
        return errors;
    };

    const { errorOf, validate } = useFormErrors(getErrors);

    const handleClickAceptar = () => {
        if (validate()) onConfirm(formValues.fecha);
    };

    return (
        <Modal
            onEscape={onCancel}
            size="md"
            title="Informe consolidado"
            body={(
                <div className="row">
                    <div className="col-12">
                        <FormLabel htmlFor="fecha" required>Fecha de consolidación</FormLabel>
                        <DatePickerCustom
                            name="fecha"
                            className={`form-control ${errorOf('fecha') ? 'is-invalid' : ''}`}
                            value={ formValues.fecha }
                            onChange={ formHandle }
                        />
                        <FormError message={errorOf('fecha')} />
                    </div>
                </div>
            )}
            footer={<>
                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={onCancel}>Cancelar</button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={handleClickAceptar}>Aceptar</button>
            </>}
        />
    );
}

export default InformeRecaudacionConsolidadaModal;
